// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root___Mjf_","clinicsSelect":"TableHeading_clinicsSelect__3g-Fk"};